import React from 'react';
import {requestSignInForThisPage} from "../utils/url";

export function useRequestLogin(postLoginRedirectPath?: string) {
  return React.useCallback(() => requestSignInForThisPage(postLoginRedirectPath), []);
}